import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=b1760254&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=b1760254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1760254",
  null
  
)

export default component.exports